import { useState } from "react";
import { useAuth } from "../../context/AuthProvider";
import { useAccountLoginUrl } from "../../hooks/useAccountLoginUrl";
import { AccountNudgeBanner } from "./AccountNudgeBanner";

/**
 * Signed-out banner (E1 §2.3).
 *
 * Rendered when this device just went from a signed-in CUSTOMER to anon (the
 * stored `fg.lastAuth` was "customer"; AuthProvider sets `state.signedOut`).
 * Their Shopify session lapsed / they logged out on the storefront, so their
 * plans live on an account they're no longer signed into — nudge them to sign
 * back in rather than treating them as a brand-new visitor.
 *
 * Shares markup/styling with `<PromotedSessionBanner>` via `<AccountNudgeBanner>`
 * (E1 consolidation, one implementation / two messages). The two states are
 * mutually exclusive at the source — AuthProvider only sets `signedOut` when
 * there is no live promoted hint (`promotedHint` wins) — so the banners never
 * stack. Dismiss hides it for the session (component state); it re-arms on the
 * next app mount while the device is still signed out.
 */
export function SignedOutBanner() {
  const { state } = useAuth();
  const loginUrl = useAccountLoginUrl();
  const [dismissed, setDismissed] = useState(false);

  if (state.kind !== "anon" || !state.signedOut || dismissed) {
    return null;
  }

  return (
    <AccountNudgeBanner
      icon="user"
      message="You're signed out — Sign in to see your plans"
      ctaLabel="Sign in"
      loginUrl={loginUrl}
      onDismiss={() => setDismissed(true)}
    />
  );
}
